import axios from "axios";

const ADD_USER_API = "https://us-central1-retail-jkommerce-poc.cloudfunctions.net/add_user";

/**
 * Sign up a new user.
 * @param {Object} payload - { username, email, password, user_role }
 * @returns {Promise<{ customer_id: number, message: string }>}
 */
export const signUpUser = async (payload) => {
  const response = await axios.post(ADD_USER_API, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};
